import { Field, InjectedFormProps, reduxForm } from 'redux-form';
import * as React from 'react';
import { fourDigits, mustBeChecked, required } from '../../shared/Forms/validations';
import Grid from '@material-ui/core/Grid/Grid';
import TextField from '@material-ui/core/TextField/TextField';
import stateMap from './stateMap';
import Button from '@material-ui/core/Button/Button';
import { keys } from 'ramda';
import {
  CheckBoxField,
  FullWidthTextField,
  SelectField,
} from '../../shared/Forms/FullWidthForm/fullWidthFormComponents';

const PersonalDetailsForm = ({ handleSubmit }: InjectedFormProps) => (
  <form onSubmit={handleSubmit}>
    <Field
      name="firstName"
      type="text"
      component={FullWidthTextField}
      label="First Name (use legal name)"
      validate={required}
    />
    <Field
      name="lastName"
      type="text"
      component={FullWidthTextField}
      label="Last Name"
      validate={required}
    />
    <Field
      name="dateOfBirth"
      type="date"
      component={FullWidthTextField}
      label="Date Of Birth"
      validate={required}
    />
    <Field
      name="streetAddress"
      type="text"
      component={FullWidthTextField}
      label="Street Address"
      validate={required}
    />
    <Field
      name="streetAddress2"
      type="text"
      component={FullWidthTextField}
      label="Apartment / Suite (optional)"
    />
    <Field
      name="city"
      type="text"
      component={FullWidthTextField}
      label="City"
      validate={required}
    />
    <Field
      name="state"
      type="text"
      dataMap={stateMap}
      component={SelectField}
      label="State / Region"
      validate={required}
    />
    <Field
      name="postalCode"
      type="number"
      component={FullWidthTextField}
      label="Postal Code"
      validate={required}
    />
    <Field
      name="lastSSN"
      type="number"
      component={FullWidthTextField}
      label="Last 4 Digits of SSN"
      validate={[required, fourDigits]}
    />
    <Grid container direction="column" align-items="flex-start">
      <Field
        name="agreedToTerms"
        component={CheckBoxField}
        type="checkbox"
        label="By checking this box, you confirm:"
        validate={mustBeChecked}
      />
      <TextField
        id="terms"
        defaultValue="Bitters hexagon copper mug salvia unicorn swag pinterest raw denim single-origin coffee bicycle rights sartorial. Dreamcatcher flexitarian kinfolk, shoreditch leggings copper mug enamel pin franzen small batch tacos bushwick. Woke umami helvetica 90's gluten-free. Lumbersexual salvia cloud bread, irony bushwick celiac art party. Drinking vinegar mlkshk venmo poutine lumbersexual aesthetic chillwave quinoa tofu tacos.
Four dollar toast chillwave artisan man braid polaroid jianbing blog knausgaard gluten-free occupy tumeric vexillologist. Flannel air plant fam taiyaki letterpress, pour-over tilde shaman helvetica. Mumblecore edison bulb gastropub cold-pressed kale chips, health goth cred YOLO forage bitters street art waistcoat. Slow-carb semiotics banjo tote bag.
Humblebrag gentrify tattooed air plant lumbersexual sriracha PBR&B fashion axe aesthetic tofu vegan food truck brunch roof party prism. Poke ethical fashion axe four dollar toast DIY unicorn mlkshk, tilde shabby chic brunch kale chips. Food truck DIY slow-carb yr knausgaard franzen quinoa austin tousled pop-up you probably haven't heard of them gastropub cred adaptogen cronut. Brooklyn vegan man braid mlkshk artisan meditation. Semiotics street art taiyaki messenger bag. Chicharrones etsy sustainable kickstarter cardigan salvia vice pitchfork, taiyaki freegan. Listicle iceland bitters copper mug normcore vape lomo ennui selfies +1 hoodie succulents.
Humblebrag etsy la croix succulents aesthetic beard microdosing truffaut. Tumeric palo santo affogato 8-bit tofu beard synth microdosing schlitz. Banh mi pickled taxidermy franzen, ennui art party cornhole knausgaard sartorial disrupt. Vape kitsch raw denim pinterest brooklyn, chicharrones flexitarian fanny pack affogato twee copper mug etsy lomo kickstarter tote bag. Slow-carb flexitarian green juice, umami chambray plaid butcher humblebrag 90's ramps mlkshk chartreuse. Food truck authentic salvia, affogato gentrify man bun lo-fi listicle venmo slow-carb.
Salvia meh put a bird on it four dollar toast copper mug tumblr cronut whatever helvetica iceland vinyl cold-pressed typewriter umami PBR&B. Echo park schlitz narwhal brunch. Banh mi art party glossier wayfarers, cred keffiyeh iceland brunch paleo meditation DIY kombucha cold-pressed chartreuse. Cloud bread banjo intelligentsia lumbersexual mlkshk venmo. Distillery listicle poke jianbing, try-hard keytar scenester."
        margin="none"
        multiline
        rowsMax="4"
        InputProps={{
          readOnly: true,
        }}
        variant="outlined"
      />
    </Grid>
    {/* TODO: Add Recaptcha back when/if needed. */}
    {/*<Field name="captchaResponse" component={Captcha} validate={required} />*/}

    <Grid style={{ margin: '20px 0' }} container justify="center">
      <Button size="large" variant="contained" color="primary" type="submit">
        Submit
      </Button>
    </Grid>
    <Grid style={{ margin: '20px 0' }} container justify="center">
      * Clicking submit may affect your credit score.
    </Grid>
  </form>
);

// const Captcha = (props: WrappedFieldProps) => (
//   <div style={{ margin: '20px 0' }}>
//     <ReCAPTCHA sitekey={config.captchaKey} onChange={props.input.onChange} />
//     <Grid container justify="center">
//       {props.meta && props.meta.touched && props.meta.error && <span>{props.meta.error}</span>}
//     </Grid>
//   </div>
// );

export default reduxForm({
  form: 'personalDetailsForm',
  onSubmitFail: (errors: any) => {
    const errorEle = document.getElementById(String(keys(errors)[0]));
    return errorEle ? errorEle!.scrollIntoView() : undefined;
  },
})(PersonalDetailsForm);
